// Libraries
var React = require('react');

// Components
//var InlineShareModule = require('InlineShare/InlineShareModule');
var BlockQuoteModule = require('BlockQuote/BlockQuote');

// Assets
//var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
//require('./Quote.scss');
require('BlockQuote/BlockQuote.scss');

class QuoteModule extends React.Component {
	constructor(props) {

		super(props);
	
		this.state = {
			blockquoteData: {
				isPremium: false,
				text: this.props.data.quote,
				name: this.props.data.author,
				role: "",
				alternate: true
			}
		}
	
	}

	render() {
		return (
			<BlockQuoteModule data={this.state.blockquoteData} />
			// <div className="Quote">
				

			// 	{this.props.data.image &&
			// 		<div className={"Quote__overlay--" + (this.props.data.position ? this.props.data.position : "left ") + ' ' + (this.props.data.backgroundColour ? this.props.data.backgroundColour : "pitch-green")}>
			// 			<div className="Text__wrapper">
			// 				<blockquote cite={this.props.data.author}>{this.props.data.quote}</blockquote>
			// 				<div className="border"></div>
			// 				<p>{this.props.data.author}</p>
			// 			</div>
			// 		</div>
			// 	}
			// 	{this.props.data.image &&
			// 		<div className="Quote__image">
			// 			<div className="Quote__image__container">
			// 					<img src={PlaceholderImg} data-src={this.props.data.image.smallUrl + '*,*' + this.props.data.image.mediumUrl + '*,*' + this.props.data.image.largeUrl + '*,*' + this.props.data.image.extraLargeUrl} alt={this.props.data.image.altText} />
			// 			</div>
			// 		</div>
			// 	}

			// 	{!this.props.data.image &&
			// 		<div className={"Quote__overlay--noImage " + (this.props.data.backgroundColour ? this.props.data.backgroundColour : "light-gray")}>
			// 			<div className="Text__wrapper">
			// 				<blockquote cite={this.props.data.author}>{this.props.data.quote}</blockquote>
			// 				<div className="border"></div>
			// 				<p>{this.props.data.author}</p>
			// 			</div>
			// 		</div>
			// 	}

			// 	{this.props.data.sharing &&
			// 		<div className="Quote__share">
			// 			<InlineShareModule data={this.props.data.sharing} />
			// 		</div>
			// 	}

			// </div>
		)
	}
}

module.exports = QuoteModule;



// WEBPACK FOOTER //
// ./src/components/Quote/QuoteModule.js